export const Signature = `%c
__   ___         _            _          _
\\ \\ / (_)       / \\   _ __   | |    __ _(_)
 \\ V /| | ___  / _ \\ | '_ \\  | |   / _\` | |
  | | | | ___ / ___ \\| | | | | |__| (_| | |
  |_| |_|    /_/   \\_\\_| |_| |_____\\__,_|_|
`;
